<!-- 薪资发放 -->
<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
                <a-form-item label="单位名称">
                    <a-select showSearch option-filter-prop="children" class="search-select" placeholder="全部" v-model="searchInfo.companyId">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in companyMap" :key="item.id" :value="item.id">{{item.companyName}}</a-select-option>
                    </a-select>
                </a-form-item>
                
                <a-form-item label="班组名称">
                    <a-select showSearch option-filter-prop="children" class="search-select" placeholder="全部" v-model="searchInfo.teamId">
                       <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="(item,key) in teamMap" :key="key" :value="item.id">{{item.teamName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="结算类型">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.type">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.status">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option :value="1">启用</a-select-option>
                        <a-select-option :value="0">禁用</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" class="m-r-8" @click="search"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                </a-form-item>
            </a-form>
            <a-row class="right-action-panel m-t-14">
                <router-link class="item" to="/pcms/salary/setting/add"><a-button type="primary" >添加</a-button></router-link>
            </a-row>
        </section>

        <section class="list-table-container m-t-18">
            
            <a-table size="small" :columns="columns" :data-source="listData" :pagination="{total,hideOnSinglePage:true,pageSize,showTotal:(total) => `共${total}条`,size:'default',showQuickJumper:true,showSizeChanger:false}" @change="changePageNum">
                <span slot="status" slot-scope="text" :style="{color:text == 1 ? '#52C41A' : '#FF555E'}">{{text == 1 ? '启用' : text == 0 ?'禁用': ''}}</span>
                <a slot="action" slot-scope="text,list">
                    <router-link class="m-r-10" :to="{path:'/pcms/salary/setting/edit',query:{id:list.id}}">编辑</router-link>
                    <a-popconfirm class="m-r-10" :title="'确定'+(list.status == 1 ? '禁用' : '启用')+'该工资设置?'" @confirm="changeItemStatus(list)">{{list.status == 1 ? '禁用' : '启用'}}</a-popconfirm>
                    <a-popconfirm title="确定删除该工资设置?" @confirm="deleteItem(list.id)">删除</a-popconfirm>
                </a>
            </a-table>
        </section>
    </section>
</template>

<script>
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key',width:80},
    {title:'单位名称',dataIndex:'companyName',align:'center',key:'companyName',width:240,ellipsis:true},
    {title:'班组名称',dataIndex:'teamName',align:'center',key:'teamName'},
    {title:'人员姓名',dataIndex:'personnelName',align:'center',key:'personnelName'},
    {title:'结算类型',dataIndex:'typeName',align:'center',key:'typeName'},
    {title:'结算单价(元)',dataIndex:'payPrice',align:'center',key:'payPrice'},
    // {title:'加班单价/小时',dataIndex:'overtimePrice',align:'center',key:'overtimePrice'},
    {title:'状态',dataIndex:'status',align:'center',key:'status',scopedSlots:{customRender: "status"}},
    {title:'备注',dataIndex:'remarks',align:'center',key:'remarks',width:'120px',ellipsis:true},
    {title:'操作',dataIndex:'action',align:'center',scopedSlots:{customRender: "action"}},
    
]
export default {
    data(){
        return{
            columns,
            total:0,
            pageSize:10,
            pageNum:1,
            listData:[],
            companyMap:[],
            searchInfo:{},
            typeList:[],
            teamMap:[]
        }
    },
    created(){
       this.init() 
    },
    mounted(){
        this.queryCompanyPaySalaryConfigList()
    },
    methods:{
        init(){
            this.queryCompanyDropDownBox()
            this.queryTeamDropDownBox()
            this.queryCompanyPayTypeList()
        },
        //单位下拉
        queryCompanyDropDownBox(){
            this.$api.queryCompanyDropDownBox().then(res =>{
                if(res.code === 200){
                    this.companyMap = res.data || []
                }
            })
        },
        //班组下拉
        queryTeamDropDownBox(){
             this.$api.queryTeamDropDownBox().then(res =>{
                if(res.code === 200){
                    this.teamMap = res.data || []
                }
            })
        },
        //结算类型下拉
        queryCompanyPayTypeList(){
            this.$api.queryCompanyPayTypeList({size:1000}).then(res =>{
                if(res.code === 200){
                    this.typeList = (res.data && res.data.records) || []
                }
            })
        },
        //查询薪资统计列表
        queryCompanyPaySalaryConfigList(){
            let params = {...this.searchInfo}
            params.current = this.pageNum
            params.size = this.pageSize
            this.$api.queryCompanyPaySalaryConfigList(params).then(res =>{
                if(res.code === 200){
                    this.listData = (res.data && res.data.records) || []
                    this.total = (res.data && res.data.total) || 0
                    this.listData.forEach((item,ind) =>{
                        item.key = (this.pageSize*(this.pageNum - 1))+ind+1
                    })
                }
            })
        },
        //重置
        reset(){
            this.searchInfo = {}
            this.pageNum = 1
            this.queryCompanyPaySalaryConfigList()
        },
        search(){
            this.pageNum = 1
            this.queryCompanyPaySalaryConfigList()
        },
        //分页
        changePageNum(p){
            this.pageNum = p.current
            this.queryCompanyPaySalaryConfigList()
        },
        //删除
        deleteItem(id){
            this.$api.deleteCompanyPaySalaryConfig(id).then(res =>{
                if(res.code === 200){
                    this.queryCompanyPaySalaryConfigList()
                }
            })
        },
        changeItemStatus(list){
            let status = list.status == 1 ? '0' : '1'
            this.$api.updateCompanyPaySalaryConfig({id:list.id,status}).then(res =>{
                if(res.code === 200){
                    this.queryCompanyPaySalaryConfigList()
                }
            })
        },
    }
}
</script>